import { takeLatest, put } from 'redux-saga/effects';
import { config } from '../../config/awsConfig';
import { API } from 'aws-amplify';
import * as actions from './actions';
import * as constants from './constants';

function* doGetStoryDetails(action) {
  try {
    const response = yield API.get(config.apiGateway.NAME, encodeURI(`/viewer/${action.id}`), {
      headers: {
        'x-api-key': config.apiKey
      }
    });
    const story = response.story;
    const pointsOfInterest = response.pointsOfInterest;
    yield put(actions.getStoryDetailsSuccess(story, pointsOfInterest));
  } catch (error) {
    yield put(actions.getStoryDetailsFailure([error]));
  }
}

export default function* storyDetailsSaga() {
  yield takeLatest(constants.STORY_DETAILS_LAUNCHED, doGetStoryDetails);
}
